import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import AppModal from "../../Common/AppModal";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCustomersListData } from "../../../store/customers/action";
import { getProductList } from "../../../store/products/action";
import classnames from "classnames";
import Select from "../../Common/AppSelect";
import { isEmpty } from "lodash";
import {
  createContractItemSuccess,
  createContractWithItems,
  getContractItemRenewalFrequencyList,
  getContractItemsList,
  getContractItemsStatusList,
  getContractList,
  getContractStatusList,
  getContractUnitFrequencyList,
  getSingleContractItem,
  updateContractItemSuccess,
  updateContractWithItems,
} from "../../../store/contract/action";
import moment from "moment";
import { AppDatePicker } from "../../Common/AppDateTimePicker";
import { preferredBillingCycleDayList } from "../../../common/data/preferredBillingCycle";
import TabContractItems from "./tabContractItems";
import { getProductUnitTypeList } from "../../../store/product/action";
import { getMasterTimeFrameIntervalList } from "../../../store/masterTimeFrameInterval/action";
import { toast } from "react-toastify";
import TabFinish from "./tabFinish";
import { getPaymentMethodList } from "../../../store/paymentMethod/action";
import {
  handleValidDateTime,
  RestructuredDate,
} from "../../Common/HandleDateTime";
import ConfirmCustomerChange from "../confirmCustomerChange";
import LoadingSpinner from "../../Common/Spinner";
const CreateContractItem = ({
  modalCreateContractItem,
  setModalCreateContractItem,
  toggleCreateContractItem,
  isEdit,
  setIsEdit,
  singleCustomer,
  selectedEditContractItemId,
}) => {
  const dispatch = useDispatch();
  const {
    createContractWithItemsSuccessResponse,
    CreateContractWithItemsSuccessLoading,
    getSingleContractItem_Contract_Data,
    getSingleContractItem_Contract_Item_List,
  } = useSelector((state) => ({
    createContractWithItemsSuccessResponse:
      state.Contract.CreateContractWithItemsSuccess,
    getSingleContractItem_Contract_Data:
      state.Contract.singleContractItem?.contract_data,
    getSingleContractItem_Contract_Item_List:
      state.Contract.singleContractItem?.contractitem_list,
    CreateContractWithItemsSuccessLoading:
      state.Contract.CreateContractWithItemsSuccessLoading,
  }));
  const { customersList } = useSelector((state) => ({
    customersList: state.Customers?.customersDataList?.customer_list,
  }));

  const contractItemObjectInitial = {
    Customer_Id: singleCustomer ? singleCustomer : "",
    Contract_Id: "",
    Title: "",
    PrintedTitle: "",
    Description: "",
    StartDateTime: "",
    EndDateTime: "",
    RenewalDateTime: "",
    ContractStatus_Id: [],
    AutoInvoiceEmail: 1,
    PreferredBillingCycleDay: {
      value: 99,
      label: "None",
      id: 99,
    },
    UnitFrequency_Id: [],
    PaymentMethod_Id: [],
    DueDateTimeLogicValue: "",
    DueDateTimeLogic_MasterTimeFrameInterval_Id: [],
  };
  const contractItems_listInitial = [
    {
      //create dynamic id 1 if 1 deleted then create 2
      id: 1,
      title: "",
      description: "",
      selectedProduct: [],
      rate: "0.00",
      selectedProductUnit: [],
      RenewalFrequency_Id: [],
      quantity: 1,
      price: 0,
      vatRate: 20,
      totalExVat: 0,
      totalIncVat: 0,
      AllowedJobAllocation: 2,
      FlagTimeActive: 0,
      StartDateTime: "",
      EndDateTime: "",
      RenewalPeriodStartDateTime: "",
      show_item: true,
      whiteLabel: false,
      WhiteLabel__Customer_Id: null,
      FlagCommitmentEnabled: "0",
      CommitmentStartDateTime: "",
      CommitmentEndDateTime: "",
      CommitmentRenewalDateTime: "",
      AutoEmailCustomer: "0",
      CreditMins: "0",
      CreditMinsShow: false,
      TimeTracked: 0,
      // Change #100719 - new lines follow the product's price
      PricingSource: "PRODUCT",
      PricingDateMode: "PERIOD_START",
    },
  ];

  const [contractItemObject, setContractItemObject] = useState(
    contractItemObjectInitial
  );
  const [contractItems_list, setContractItems_list] = useState(
    contractItems_listInitial
  );
  const [contractId, setContractId] = useState("");
  const { productListApi } = useSelector((state) => ({
    productListApi: state.Products.productsList?.product_list,
  }));

  const { SingleCustomerContractList } = useSelector((state) => ({
    SingleCustomerContractList:
      state.Contract.singleCustomerSearchContracts?.contract_list,
  }));

  const { ContractStatusListApi } = useSelector((state) => ({
    ContractStatusListApi:
      state.Contract.contractStatusList?.contractstatus_list,
  }));

  const { ContractItemsStatusListApi } = useSelector((state) => ({
    ContractItemsStatusListApi:
      state.Contract.contractItemsStatusList?.contractitemstatus_list,
  }));
  // Local State
  const { ContractUnitFrequencyListApi } = useSelector((state) => ({
    ContractUnitFrequencyListApi:
      state.Contract.contractUnitFrequencyList?.unitfrequency_list,
  }));
  const { ContractCreatedSuccess } = useSelector((state) => ({
    ContractCreatedSuccess: state.Contract.CreateContractWithItemsSuccess,
  }));
  const { productUnitTypeList } = useSelector((state) => ({
    productUnitTypeList: state.ProductCrmIT.productUnitTypeList?.unittype_list,
  }));
  const {
    updateContractWithItemsSuccessResponse,
    updateContractWithItemsSuccessLoading,
  } = useSelector((state) => ({
    updateContractWithItemsSuccessResponse:
      state.Contract.updateContractWithItemsSuccess,
  }));
  const { contractItemRenewalFrequencyList } = useSelector((state) => ({
    contractItemRenewalFrequencyList:
      state.Contract.contractItemRenewalFrequencyList?.renewalfrequency_list,
  }));
  const { masterTimeFrameIntervalList } = useSelector((state) => ({
    masterTimeFrameIntervalList:
      state.MasterTimeFrameInterval.masterTimeFrameIntervalList
        ?.mastertimeframeinterval_list,
  }));
  const { paymentMethodList } = useSelector((state) => ({
    paymentMethodList:
      state.PaymentMethod.paymentMethodList?.paymentmethod_list,
  }));
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [contractItems_list_Filtered, setContractItems_list_Filtered] =
    useState([]);
  const [localSelectedEditContractItemId, setLocalSelectedEditContractItemId] =
    useState(selectedEditContractItemId ?? null);
  const [sortBy, setSortBy] = useState(1);
  const [sortByChoice, setSortByChoice] = useState([
    {
      id: 1,
      label: "Id",
      ascending: true,
    },
    {
      id: 2,
      label: "Product Name",
      ascending: true,
    },
    {
      id: 3,
      label: "Title",
      ascending: true,
    },
  ]);

  const [successCreatedContract, setSuccessCreatedContract] = useState(false);

  useEffect(() => {
    dispatch(getProductList());
    dispatch(getProductUnitTypeList());
    dispatch(getCustomersListData());
    dispatch(getContractStatusList());
    dispatch(getContractItemsStatusList());
    dispatch(getContractUnitFrequencyList());
    dispatch(getContractItemRenewalFrequencyList());
    dispatch(getPaymentMethodList());
    dispatch(getMasterTimeFrameIntervalList());
  }, []);
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "id",
    "Title",
    "Description",
  ]);
  // serach

  useEffect(() => {
    let filteredData = contractItems_list;

    // filter by sortBy and sortByChoice.ascending
    // sort by Id
    if (sortBy === 1) {
      if (sortByChoice?.filter((item) => item.id === sortBy)[0]?.ascending) {
        filteredData = filteredData?.sort((a, b) => {
          return a.id - b.id;
        });
      } else {
        filteredData = filteredData?.sort((a, b) => {
          return b.id - a.id;
        });
      }
    }
    // sort by Product Name
    if (sortBy === 2) {
      if (sortByChoice?.filter((item) => item.id === sortBy)[0]?.ascending) {
        filteredData = filteredData?.sort((a, b) => {
          if (a?.selectedProduct?.label > b?.selectedProduct?.label) {
            return -1;
          }
          if (a?.selectedProduct?.label < b?.selectedProduct?.label) {
            return 1;
          }
          return 0;
        });
      } else {
        // descending
        filteredData = filteredData?.sort((a, b) => {
          if (a?.selectedProduct?.label > b?.selectedProduct?.Name) {
            return 1;
          }
          if (a?.selectedProduct?.label < b?.selectedProduct?.label) {
            return -1;
          }
          return 0;
        });
      }
    }

    // sort by Title
    if (sortBy === 3) {
      if (sortByChoice?.filter((item) => item.id === sortBy)[0]?.ascending) {
        filteredData = filteredData?.sort((a, b) => {
          if (a?.Title > b?.Title) {
            return -1;
          }
          if (a?.Title < b?.Title) {
            return 1;
          }
          return 0;
        });
      } else {
        // descending
        filteredData = filteredData?.sort((a, b) => {
          if (a?.Title > b?.Title) {
            return 1;
          }
          if (a?.Title < b?.Title) {
            return -1;
          }
          return 0;
        });
      }
    }

    // filter by search query
    filteredData = filteredData?.filter((item) => {
      return allowedSearchFilters?.some((key) => {
        return (
          item[key] &&
          item[key]
            .toString()
            .toLowerCase()
            .includes(searchQuery?.toLowerCase())
        );
      });
    });
    setSearchResults(filteredData);
  }, [contractItems_list, searchQuery, sortBy, sortByChoice]);

  // Create Item Success response
  useEffect(() => {
    if (!successCreatedContract) return;
    if (createContractWithItemsSuccessResponse?.status === 200) {
      setSuccessCreatedContract(true);
      dispatch(createContractItemSuccess([]));
      toast.success(createContractWithItemsSuccessResponse?.message);

      // clear success state

      // Get List with updated data
      dispatch(
        getSingleContractItem({
          id: createContractWithItemsSuccessResponse?.Contract_Id,
        })
      );
      dispatch(getContractItemsList());
      dispatch(getContractList());
      setIsEdit(true);
      toggleVerticalTab(10);
    }
  }, [createContractWithItemsSuccessResponse]);

  // Update Item success response
  useEffect(() => {
    if (!successCreatedContract) return;
    if (updateContractWithItemsSuccessResponse?.status === 200) {
      setSuccessCreatedContract(false);
      toast.success(updateContractWithItemsSuccessResponse?.message);
      dispatch(
        getSingleContractItem({
          id: contractId,
        })
      );
      // clear success state
      // Get List with updated data

      dispatch(getContractItemsList());
      dispatch(getContractList());
      setIsEdit(true);
      setLocalSelectedEditContractItemId(null);
      toggleVerticalTab(10);
      dispatch(updateContractItemSuccess([]));
    }
  }, [updateContractWithItemsSuccessResponse]);

  // Vertical Nav Steps Code

  const [activeVerticalTab, setactiveVerticalTab] = useState(7);
  const [passedverticalSteps, setPassedverticalSteps] = useState([1]);

  function toggleVerticalTab(tab) {
    if (activeVerticalTab !== tab) {
      var modifiedSteps = [...passedverticalSteps, tab];
      if (handleFormValidation(tab) === true) return;
      setactiveVerticalTab(tab);
      setPassedverticalSteps(modifiedSteps);
    }
  }

  const helperSwapNumber = (number) => {
    if (number === 1) {
      return 2;
    }
    if (number === 2) {
      return 1;
    }
  };

  // Helper function on Item basket item close other items show_item: false and the one that was clicked show_item: true
  const handleItemBasketItemClose = (id) => {
    const newContractItemsList = contractItems_list.map((item) => {
      setSearchQuery("");
      if (item.id === id) {
        return {
          ...item,
          show_item: true,
        };
      } else {
        return {
          ...item,
          show_item: false,
        };
      }
    });
    setContractItems_list(newContractItemsList);
  };

  const handleFormValidation = (tab) => {
    // Step 1
    if (tab && !isEdit) {
      // if tab is not empty 1st Step tab == 7 process 1st step checks
      if (tab !== 7) {
        if (isEmpty(contractItemObject.Customer_Id)) {
          toast.error("Step 1: Please select Customer");
          return true;
        }
        // Enter Title
        if (isEmpty(contractItemObject.Title)) {
          toast.error("Step 1: Please enter Title");
          return true;
        }
      } else {
        return false;
      }
      // if tab is not empty 2nd Step tab == 8 process 2nd step checks
      if (tab !== 8) {
        // StartDateTime
        if (isEmpty(contractItemObject.StartDateTime)) {
          toast.error("Step 2: Please enter Start Date");
          return true;
        }

        // Preferred billing cycle
        if (!contractItemObject.PreferredBillingCycleDay.id) {
          toast.error("Step 2: Please select Preferred billing cycle");
          return true;
        }
        // Renewal Frequency
        if (!contractItemObject.UnitFrequency_Id.id) {
          toast.error("Step 2: Please select Renewal Frequency");
          return true;
        }
      } else {
        return false;
      }
      // if tab is not empty 3rd Step tab == 9 process 3rd step checks
      if (tab !== 9) {
        // check if contractItems_list is empty
        if (contractItems_list.some((item) => item.selectedProduct.id === "")) {
          toast.error("Step 3: Please add at least one item");
          return true;
        }
        // selectedProduct
        if (
          contractItems_list.filter((item) => !item.selectedProduct.id).length >
          0
        ) {
          contractItems_list.map((item) => {
            if (isEmpty(item.selectedProduct.id)) {
              toast.error(`Step 3:  Item ${item.id} Please select Product `);
            }
          });

          return true;
        }
        // selectedProductUnit
        if (
          contractItems_list.filter((item) => !item.selectedProductUnit.id)
            .length > 0
        ) {
          contractItems_list.map((item) => {
            if (isEmpty(item.selectedProductUnit.id)) {
              toast.error(
                `Step 3:  Item ${item.id} Please select Product Unit `
              );
            }
          });

          return true;
        }
        // Quantity
        if (
          contractItems_list.filter((item) => item.Quantity === null).length > 0
        ) {
          contractItems_list.map((item) => {
            if (item.Quantity === null) {
              toast.error(`Step 3:  Item ${item.id} Please enter Quantity `);
            }
          });

          return true;
        }
        // Price
        if (
          contractItems_list.filter((item) => item.rate === null).length > 0
        ) {
          contractItems_list.map((item) => {
            if (item.rate === null) {
              toast.error(`Step 3:  Item ${item.id} Please enter Price `);
            }
          });

          return true;
        }
        // Vat
        if (
          contractItems_list.filter((item) => item.vatRate === null).length > 0
        ) {
          contractItems_list.map((item) => {
            if (item.vatRate === null) {
              toast.error(`Step 3:  Item ${item.id} Please enter Vat `);
            }
          });

          return true;
        }
        // StartDateTime
        if (
          contractItems_list.filter((item) => !item.StartDateTime).length > 0
        ) {
          contractItems_list.map((item) => {
            if (isEmpty(item.StartDateTime)) {
              toast.error(`Step 3:  Item ${item.id} Please enter Start Date `);
              return true;
            }
          });
        }
      } else {
        return false;
      }
    }
  };

  // Create Contract with Items
  const handleCreateContractWithItems = () => {
    //Validation: 1-3 steps

    if (isEmpty(contractItemObject.Customer_Id)) {
      toast.error("Step 1: Please select Customer");
      return;
    }
    // Enter Title
    if (isEmpty(contractItemObject.Title)) {
      toast.error("Step 1: Please enter Title");
      return;
    }
    // Step 2
    // StartDateTime
    if (isEmpty(contractItemObject.StartDateTime)) {
      toast.error("Step 2: Please enter Start Date");
      return;
    }

    // Preferred billing cycle
    if (!contractItemObject.PreferredBillingCycleDay.id) {
      toast.error("Step 2: Please select Preferred billing cycle");
      return;
    }
    // Renewal Frequency
    if (!contractItemObject.UnitFrequency_Id.id) {
      toast.error("Step 2: Please select Renewal Frequency");
      return;
    }
    // Step 3
    // check if contractItems_list is empty
    if (contractItems_list.some((item) => item.selectedProduct.id === "")) {
      toast.error("Step 3: Please add at least one item");
      return;
    }
    // selectedProduct
    if (
      contractItems_list.filter((item) => !item.selectedProduct.id).length > 0
    ) {
      contractItems_list.map((item) => {
        if (isEmpty(item.selectedProduct.id)) {
          toast.error(`Step 3:  Item ${item.id} Please select Product `);
        }
      });

      return;
    }
    // selectedProductUnit
    if (
      contractItems_list.filter((item) => !item.selectedProductUnit.id).length >
      0
    ) {
      contractItems_list.map((item) => {
        if (isEmpty(item.selectedProductUnit.id)) {
          toast.error(`Step 3:  Item ${item.id} Please select Product Unit `);
        }
      });

      return;
    }
    // Quantity
    if (
      contractItems_list.filter((item) => item.Quantity === null).length > 0
    ) {
      contractItems_list.map((item) => {
        if (item.Quantity === null) {
          toast.error(`Step 3:  Item ${item.id} Please enter Quantity `);
        }
      });

      return;
    }
    // Price
    if (contractItems_list.filter((item) => item.rate === null).length > 0) {
      contractItems_list.map((item) => {
        if (item.rate === null) {
          toast.error(`Step 3:  Item ${item.id} Please enter Price `);
        }
      });

      return;
    }
    // Vat
    if (contractItems_list.filter((item) => item.vatRate === null).length > 0) {
      contractItems_list.map((item) => {
        if (item.vatRate === null) {
          toast.error(`Step 3:  Item ${item.id} Please enter Vat `);
        }
      });

      return;
    }
    // StartDateTime
    if (contractItems_list.filter((item) => !item.StartDateTime).length > 0) {
      contractItems_list.map((item) => {
        if (isEmpty(item.StartDateTime)) {
          toast.error(`Step 3:  Item ${item.id} Please enter Start Date `);
        }
      });

      return;
    }
    // RenewalPeriodStartDateTime
    if (
      contractItems_list.filter((item) => !item.RenewalPeriodStartDateTime)
        .length > 0
    ) {
      contractItems_list.map((item) => {
        if (isEmpty(item.RenewalPeriodStartDateTime)) {
          toast.error(
            `Step 3:  Item ${item.id} Please enter Service Renewal Date `
          );
        }
      });

      return;
    }
    // Renewal Frequency
    if (
      contractItems_list.filter((item) => !item.RenewalFrequency_Id.id).length >
      0
    ) {
      contractItems_list.map((item) => {
        if (isEmpty(item.RenewalFrequency_Id.id)) {
          toast.error(
            `Step 3:  Item ${item.id} Please select Renewal Frequency`
          );
        }
      });
      return;
    }

    const newContractWithItemsList = [
      {
        Customer_Id: contractItemObject.Customer_Id,
        Title: contractItemObject.Title,
        // if TitlePrinted is empty dont send it
        ...(contractItemObject.TitlePrinted && {
          TitlePrinted: contractItemObject.TitlePrinted,
        }),
        Description: contractItemObject.Description,
        StartDateTime: contractItemObject.StartDateTime ?? "",
        EndDateTime: contractItemObject.EndDateTime ?? "",
        RenewalDateTime: contractItemObject.RenewalDateTime ?? "",
        ContractStatus_Id: contractItemObject.ContractStatus_Id.id,
        AutoInvoiceEmail: Number(contractItemObject.AutoInvoiceEmail),
        PreferredBillingCycleDay:
          contractItemObject.PreferredBillingCycleDay.id,
        UnitFrequency_Id: contractItemObject.UnitFrequency_Id.id,
        PaymentMethod_Id: contractItemObject.PaymentMethod_Id.id,
        DueDateTimeLogicValue: contractItemObject.DueDateTimeLogicValue ?? "",
        DueDateTimeLogic_MasterTimeFrameInterval_Id:
          contractItemObject.DueDateTimeLogic_MasterTimeFrameInterval_Id?.id ??
          null,
        contractitem_list: contractItems_list.map((item) => {
          return {
            Product_Id: item.selectedProduct.id,
            Title: item.Title,
            Description: item.Description,
            Qty: item.quantity,
            AmountLocalEach: item.rate,
            UnitType_Id: item.selectedProductUnit.id,
            RenewalFrequency_Id: item.RenewalFrequency_Id.id,
            AmountLocalSubTotal: (item.quantity * Number(item.rate)).toFixed(2),
            AmountLocalVat: (
              item.rate *
              item.quantity *
              (item.vatRate / 100)
            ).toFixed(2),
            AmountLocalTotal: (
              item.rate * item.quantity +
              item.rate * item.quantity * (item.vatRate / 100)
            ).toFixed(2),
            AmountVatPercentage: item.vatRate,
            StartDateTime: item.StartDateTime ?? "",
            EndDateTime: item.EndDateTime ?? "",
            RenewalPeriodStartDateTime: item.RenewalPeriodStartDateTime ?? "",
            ContractItemStatus_Id: item.ContractItemStatus_Id,
            AllowedJobAllocation: Number(item.AllowedJobAllocation),
            FlagTimeActive: Number(item.FlagTimeActive),
            WhiteLabel__Customer_Id: item.WhiteLabel__Customer_Id,
            FlagCommitmentEnabled: item.FlagCommitmentEnabled,
            CommitmentStartDateTime: item.CommitmentStartDateTime,
            CommitmentEndDateTime: item.CommitmentEndDateTime,
            CommitmentRenewalDateTime: item.CommitmentRenewalDateTime,
            AutoEmailCustomer: item.AutoEmailCustomer,
            CreditMins: item.CreditMins,
            TimeTracked: item.TimeTracked,
            // Change #100719 - an older backend drops these (not in allowedFields).
            ...(item.PricingSource && { PricingSource: item.PricingSource }),
            ...(item.PricingSource === "PRODUCT" &&
              item.PricingDateMode && { PricingDateMode: item.PricingDateMode }),
          };
        }),
      },
    ];
    dispatch(createContractWithItems(newContractWithItemsList));
    setSuccessCreatedContract(true);
  };

  // Update Contract With Items
  const handleUpdateContractWithItems = () => {
    // Validation
    // Step 1

    if (isEmpty(contractItemObject.Customer_Id)) {
      toast.error("Step 1: Please select Customer");
      return;
    }
    // Enter Title
    if (isEmpty(contractItemObject.Title)) {
      toast.error("Step 1: Please enter Title");
      return;
    }
    // Step 2
    // StartDateTime
    if (isEmpty(contractItemObject.StartDateTime)) {
      toast.error("Step 2: Please enter Start Date");
      return;
    }

    // Preferred billing cycle
    if (!contractItemObject.PreferredBillingCycleDay.id) {
      toast.error("Step 2: Please select Preferred billing cycle");
      return;
    }
    // Renewal Frequency
    if (!contractItemObject.UnitFrequency_Id.id) {
      toast.error("Step 2: Please select Renewal Frequency");
      return;
    }
    // Step 3
    // check if contractItems_list is empty
    if (contractItems_list.some((item) => item.selectedProduct.id === "")) {
      toast.error("Step 3: Please add at least one item");
      return;
    }
    // selectedProduct
    if (
      contractItems_list.filter((item) => !item.selectedProduct.id).length > 0
    ) {
      contractItems_list.map((item) => {
        if (isEmpty(item.selectedProduct.id)) {
          toast.error(`Step 3:  Item ${item.id} Please select Product `);
        }
      });

      return;
    }
    // selectedProductUnit
    if (
      contractItems_list.filter((item) => !item.selectedProductUnit.id).length >
      0
    ) {
      contractItems_list.map((item) => {
        if (isEmpty(item.selectedProductUnit.id)) {
          toast.error(`Step 3:  Item ${item.id} Please select Product Unit `);
        }
      });

      return;
    }
    // Quantity
    if (
      contractItems_list.filter((item) => item.Quantity === null).length > 0
    ) {
      contractItems_list.map((item) => {
        if (item.Quantity === null) {
          toast.error(`Step 3:  Item ${item.id} Please enter Quantity `);
        }
      });

      return;
    }
    // Price
    if (contractItems_list.filter((item) => item.rate === null).length > 0) {
      contractItems_list.map((item) => {
        if (item.rate === null) {
          toast.error(`Step 3:  Item ${item.id} Please enter Price `);
        }
      });

      return;
    }
    // Vat
    if (contractItems_list.filter((item) => item.vatRate === null).length > 0) {
      contractItems_list.map((item) => {
        if (item.vatRate === null) {
          toast.error(`Step 3:  Item ${item.id} Please enter Vat `);
        }
      });

      return;
    }
    // StartDateTime
    if (contractItems_list.filter((item) => !item.StartDateTime).length > 0) {
      contractItems_list.map((item) => {
        if (isEmpty(item.StartDateTime)) {
          toast.error(`Step 3:  Item ${item.id} Please enter Start Date `);
        }
      });

      return;
    }
    // RenewalPeriodStartDateTime
    if (
      contractItems_list.filter((item) => !item.RenewalPeriodStartDateTime)
        .length > 0
    ) {
      contractItems_list.map((item) => {
        if (isEmpty(item.RenewalPeriodStartDateTime)) {
          toast.error(
            `Step 3:  Item ${item.id} Please enter Service Renewal Date `
          );
        }
      });

      return;
    }
    // Renewal Frequency
    if (
      contractItems_list.filter((item) => !item.RenewalFrequency_Id?.id)
        .length > 0
    ) {
      contractItems_list.map((item) => {
        if (isEmpty(item.RenewalFrequency_Id?.id)) {
          toast.error(
            `Step 3:  Item ${item.id} Please select Renewal Frequency`
          );
        }
      });
      return;
    }

    const updateContractWithItemsList = [
      {
        Id: contractItemObject?.Id,
        Customer_Id: contractItemObject?.Customer_Id,
        Title: contractItemObject?.Title,
        TitlePrinted: contractItemObject?.TitlePrinted,
        Description: contractItemObject?.Description,
        StartDateTime: contractItemObject?.StartDateTime,
        EndDateTime: contractItemObject?.EndDateTime,
        RenewalDateTime: contractItemObject?.RenewalDateTime,
        ContractStatus_Id: contractItemObject?.ContractStatus_Id.id,
        AutoInvoiceEmail: Number(contractItemObject?.AutoInvoiceEmail),
        PreferredBillingCycleDay:
          contractItemObject?.PreferredBillingCycleDay?.id,
        UnitFrequency_Id: contractItemObject?.UnitFrequency_Id?.id,
        PaymentMethod_Id: contractItemObject?.PaymentMethod_Id?.id,
        DueDateTimeLogicValue: contractItemObject?.DueDateTimeLogicValue ?? "",
        DueDateTimeLogic_MasterTimeFrameInterval_Id:
          contractItemObject?.DueDateTimeLogic_MasterTimeFrameInterval_Id?.id ??
          null,
        contractitem_list: contractItems_list.map((item) => {
          return {
            // check if item.id exits inside getSingleContractItem_Contract_Item_List

            ...(getSingleContractItem_Contract_Item_List?.some(
              (contractItems) => contractItems.Id == item.id
            ) && { Id: item?.id }),
            Product_Id: item?.selectedProduct?.id,
            Title: item?.Title,
            Description: item?.Description,
            Qty: item?.quantity,
            AmountLocalEach: item?.rate,
            UnitType_Id: item?.selectedProductUnit?.id,
            RenewalFrequency_Id: item?.RenewalFrequency_Id?.id,
            AmountLocalSubTotal: (item?.quantity * Number(item?.rate)).toFixed(
              2
            ),
            AmountLocalVat: (
              item?.rate *
              item?.quantity *
              (item?.vatRate / 100)
            ).toFixed(2),
            AmountLocalTotal: (
              item?.rate * item?.quantity +
              item?.rate * item?.quantity * (item?.vatRate / 100)
            ).toFixed(2),
            AmountVatPercentage: item?.vatRate,
            StartDateTime: item?.StartDateTime,
            EndDateTime: item?.EndDateTime,
            RenewalPeriodStartDateTime: item?.RenewalPeriodStartDateTime,
            ContractItemStatus_Id: item?.ContractItemStatus_Id,
            AllowedJobAllocation: Number(item?.AllowedJobAllocation),
            FlagTimeActive: Number(item?.FlagTimeActive),
            WhiteLabel__Customer_Id: item?.WhiteLabel__Customer_Id,
            FlagCommitmentEnabled: item?.FlagCommitmentEnabled,
            CommitmentStartDateTime: item?.CommitmentStartDateTime,
            CommitmentEndDateTime: item?.CommitmentEndDateTime,
            CommitmentRenewalDateTime: item?.CommitmentRenewalDateTime,
            AutoEmailCustomer: item?.AutoEmailCustomer,
            CreditMins: item?.CreditMins,
            TimeTracked: item?.TimeTracked,
            // Change #100719 - an older backend drops these (not in allowedFields).
            ...(item?.PricingSource && { PricingSource: item.PricingSource }),
            ...(item?.PricingSource === "PRODUCT" &&
              item?.PricingDateMode && { PricingDateMode: item.PricingDateMode }),
          };
        }),
      },
    ];

    dispatch(updateContractWithItems(updateContractWithItemsList));
    setSuccessCreatedContract(true);
  };

  // Receive Contract Data and assign to local state
  useEffect(() => {
    if (!isEdit) return;
    if (
      isEmpty(
        getSingleContractItem_Contract_Data ||
          getSingleContractItem_Contract_Item_List
      )
    )
      return;
    setContractId(getSingleContractItem_Contract_Data?.Id);
    setContractItemObject({
      Id: getSingleContractItem_Contract_Data?.Id,
      Customer_Id: getSingleContractItem_Contract_Data?.Customer_Id,
      Title: getSingleContractItem_Contract_Data?.Title,
      TitlePrinted: getSingleContractItem_Contract_Data?.TitlePrinted,
      Description: getSingleContractItem_Contract_Data?.Description,
      StartDateTime: getSingleContractItem_Contract_Data?.StartDateTime,
      EndDateTime: getSingleContractItem_Contract_Data?.EndDateTime,
      RenewalDateTime: getSingleContractItem_Contract_Data?.RenewalDateTime,
      ContractStatus_Id: {
        label: ContractStatusListApi?.find(
          (status) =>
            status?.Id ===
            getSingleContractItem_Contract_Data?.ContractStatus_Id
        )?.Name,
        value: getSingleContractItem_Contract_Data?.ContractStatus_Id,
        id: getSingleContractItem_Contract_Data?.ContractStatus_Id,
      },
      AutoInvoiceEmail: Number(
        getSingleContractItem_Contract_Data?.AutoInvoiceEmail
      ),
      PreferredBillingCycleDay: {
        label: preferredBillingCycleDayList?.find(
          (pbc) =>
            pbc.id ==
            getSingleContractItem_Contract_Data?.PreferredBillingCycleDay
        )?.label,
        value: getSingleContractItem_Contract_Data?.PreferredBillingCycleDay,
        id: getSingleContractItem_Contract_Data?.PreferredBillingCycleDay,
      },
      UnitFrequency_Id: {
        label: ContractUnitFrequencyListApi?.find(
          (unitFquery) =>
            unitFquery?.Id ===
            getSingleContractItem_Contract_Data?.UnitFrequency_Id
        )?.Name,
        value: getSingleContractItem_Contract_Data?.UnitFrequency_Id,
        id: getSingleContractItem_Contract_Data?.UnitFrequency_Id,
      },
      PaymentMethod_Id: {
        label: paymentMethodList?.find(
          (paymentMethod) =>
            paymentMethod?.Id ===
            getSingleContractItem_Contract_Data?.PaymentMethod_Id
        )?.Name,
        value: getSingleContractItem_Contract_Data?.PaymentMethod_Id,
        id: getSingleContractItem_Contract_Data?.PaymentMethod_Id,
      },
      DueDateTimeLogicValue:
        getSingleContractItem_Contract_Data?.DueDateTimeLogicValue ?? "",
      DueDateTimeLogic_MasterTimeFrameInterval_Id:
        getSingleContractItem_Contract_Data?.DueDateTimeLogic_MasterTimeFrameInterval_Id
          ? {
              label: masterTimeFrameIntervalList?.find(
                (interval) =>
                  interval?.Id ===
                  getSingleContractItem_Contract_Data?.DueDateTimeLogic_MasterTimeFrameInterval_Id
              )?.Name,
              value:
                getSingleContractItem_Contract_Data?.DueDateTimeLogic_MasterTimeFrameInterval_Id,
              id: getSingleContractItem_Contract_Data?.DueDateTimeLogic_MasterTimeFrameInterval_Id,
            }
          : [],
    });

    setContractItems_list(
      getSingleContractItem_Contract_Item_List.map((item) => {
        return {
          id: Number(item?.Id),
          selectedProduct: {
            label: productListApi?.find(
              (product) => product?.Id === item?.Product_Id
            )?.Name,
            value: item?.Product_Id,
            id: item?.Product_Id,
          },
          Title: item?.Title,
          Description: item?.Description,
          quantity: Number(item?.Qty),
          rate: Number(item?.AmountLocalEach) ?? 0,
          selectedProductUnit: {
            label: productUnitTypeList?.find(
              (productUnitType) => productUnitType?.Id === item?.UnitType_Id
            )?.Name,
            value: item?.UnitType_Id,
            id: item?.UnitType_Id,
          },
          RenewalFrequency_Id: {
            label: contractItemRenewalFrequencyList?.find(
              (UnitFrequency) => UnitFrequency?.Id === item?.RenewalFrequency_Id
            )?.Name,
            value: item?.RenewalFrequency_Id,
            id: item?.RenewalFrequency_Id,
          },
          vatRate: Number(item?.AmountVatPercentage),
          StartDateTime: item?.StartDateTime,
          EndDateTime: item?.EndDateTime,
          RenewalPeriodStartDateTime: item?.RenewalPeriodStartDateTime,
          ContractItemStatus_Id: item?.ContractItemStatus_Id,
          AllowedJobAllocation: Number(item?.AllowedJobAllocation),
          FlagTimeActive: Number(item?.FlagTimeActive),
          show_item: item.Id === localSelectedEditContractItemId,
          whiteLabel: !!item?.WhiteLabel__Customer_Id,
          WhiteLabel__Customer_Id: item?.WhiteLabel__Customer_Id,
          FlagCommitmentEnabled: item?.FlagCommitmentEnabled,
          CommitmentStartDateTime: item?.CommitmentStartDateTime,
          CommitmentEndDateTime: item?.CommitmentEndDateTime,
          CommitmentRenewalDateTime: item?.CommitmentRenewalDateTime,
          AutoEmailCustomer: item?.AutoEmailCustomer,
          CreditMins: item?.CreditMins,
          CreditMinsShow: !!item?.CreditMins,
          TimeTracked: +item?.TimeTracked,
          // Change #100719 - saved lines keep their own price unless set otherwise
          PricingSource: item?.PricingSource || "CUSTOM",
          PricingDateMode: item?.PricingDateMode || "PERIOD_START",
        };
      })
    );
    if (localSelectedEditContractItemId) {
      toggleVerticalTab(9);
      setSearchQuery(localSelectedEditContractItemId);
    }
  }, [
    isEdit,
    getSingleContractItem_Contract_Data,
    getSingleContractItem_Contract_Item_List,
    preferredBillingCycleDayList,
    contractItemRenewalFrequencyList,
    masterTimeFrameIntervalList,
    productListApi,
  ]);

  // Reset from once clicked on Create New Contract
  useEffect(() => {
    if (!isEdit) {
      toggleVerticalTab(7);
      // reset form

      setContractItemObject(contractItemObjectInitial);
      setContractItems_list(contractItems_listInitial);
    }
  }, [isEdit, customersList, singleCustomer]);

  //if contract create called from single custoemer update custoemr id

  // API total ex vat
  const contractItemsReducedAPiTotal =
    getSingleContractItem_Contract_Item_List?.reduce(
      (total, item) =>
        total + Number(item?.AmountLocalEach) * Number(item?.Qty),
      0
    );

  // Local state total ex vat
  const contractItemsReducedLocalStateTotal = contractItems_list?.reduce(
    (total, item) => total + Number(item?.rate) * Number(item?.quantity),
    0
  );

  // API total inc vat
  const contractItemsReducedAPiTotalIncVat =
    getSingleContractItem_Contract_Item_List?.reduce(
      (total, item) =>
        total +
        Number(item?.AmountLocalEach) * Number(item?.Qty) +
        //if vat rate is > 0 then add vat
        (Number(item?.AmountVatPercentage) > 0
          ? (Number(item?.AmountLocalEach) *
              Number(item?.Qty) *
              Number(item?.AmountVatPercentage)) /
            100
          : 0),
      0
    );

  // Local state total inc vat
  const contractItemsReducedLocalStateTotalIncVat = contractItems_list?.reduce(
    (total, item) =>
      total +
      Number(item?.rate) * Number(item?.quantity) +
      //if vat rate is > 0 then add vat
      (Number(item?.vatRate) > 0
        ? (Number(item?.rate) *
            Number(item?.quantity) *
            Number(item?.vatRate)) /
          100
        : 0),
    0
  );

  const [changeCustomerTo, setChangeCustomerTo] = useState(null);
  const [confirmCustomerChange, setConfirmCustomerChange] = useState(false);
  const toggleConfirmCustomerChange = () => {
    setConfirmCustomerChange(!confirmCustomerChange);
  };

  const handleChangeAddressAndCustomer = (id) => {
    setContractItemObject({
      ...contractItemObject,
      Customer_Id: id ?? changeCustomerTo,
    });

    setConfirmCustomerChange(false);
  };

  const handleSwapCustomerKeepPricing = () => {
    handleChangeAddressAndCustomer();

    console.log("Change customer and keep Pricing Action Initiated");
  };
  const handleSwapCustomerUpdatePricing = () => {
    handleChangeAddressAndCustomer();
    // update pricing
    // update prices for all product items with customer price if there is one
    let tempList = contractItems_listInitial;
    tempList?.map((productItem, index) => {
      if (isEmpty(productItem?.selectedProduct)) return;
      if (
        !isEmpty(
          productListApi
            ?.find(
              (ProductListitem) =>
                ProductListitem.Id === productItem?.selectedProduct
            )
            ?.productpricing_list?.find(
              (productPriceItem) =>
                productPriceItem.Customer_Id === changeCustomerTo
            )
        )
      ) {
        console.log(
          "***** Product Found******** and includes customer ID",
          productListApi
            ?.find((item) => item.Id === productItem?.selectedProduct)
            ?.productpricing_list.find(
              (productPriceItem) =>
                productPriceItem.Customer_Id === changeCustomerTo
            )
        );

        tempList[index].rate = productListApi
          ?.find((item) => item.Id === productItem?.selectedProduct)
          ?.productpricing_list.find(
            (productPriceItem) =>
              productPriceItem.Customer_Id === changeCustomerTo
          )?.AmountLocalSubTotal;
        tempList[index].vatRate = productListApi
          ?.find(
            (ProductListitem) =>
              ProductListitem.Id === productItem?.selectedProduct
          )
          ?.productpricing_list.find(
            (productPriceItem) =>
              productPriceItem.Customer_Id === changeCustomerTo
          )?.AmountVatPercentage;
      } else {
        console.log(
          "******* Product Found but dose not include customer ID ******** Use Default Price"
        );
        tempList[index].rate =
          productListApi?.find(
            (item) => item.Id === productItem?.selectedProduct
          )?.AmountLocalSubTotal ?? 0;
        tempList[index].vatRate =
          productListApi?.find(
            (ProductListitem) =>
              ProductListitem.Id === productItem?.selectedProduct
          )?.AmountVatPercentage ?? 0;
      }
    });

    setContractItemObject(tempList);
  };

  return (
    <div>
      {confirmCustomerChange && (
        <ConfirmCustomerChange
          modal={confirmCustomerChange}
          toggle={toggleConfirmCustomerChange}
          keep={() => {
            handleSwapCustomerKeepPricing();
          }}
          update={() => {
            handleSwapCustomerUpdatePricing();
          }}
        />
      )}
      <AppModal
        open={modalCreateContractItem}
        onClose={() => {
          setModalCreateContractItem(false);
          setIsEdit(false);
        }}
        title={
          isEdit ? (
            <>
              <span className={"fw-bold"}> Editing Contract </span>#
              {contractItemObject?.Id}{" "}
              {contractItemObject?.Title && (
                <span>
                  <span className={"fw-bold"}>Title: </span>
                  {contractItemObject?.Title}
                </span>
              )}
              {contractItemObject?.Customer_Id && (
                <span>
                  <span className={"fw-bold"}> Customer: </span>
                  {
                    customersList?.find(
                      (customer) =>
                        customer?.Id === contractItemObject?.Customer_Id
                    )?.FullName
                  }
                </span>
              )}
            </>
          ) : (
            <>
              <span className={" "}>Create Contract </span>

              {contractItemObject?.Title && (
                <span>
                  <span className={"fw-bold"}>Title: </span>
                  {contractItemObject?.Title}
                </span>
              )}
              {contractItemObject?.Customer_Id && (
                <span>
                  <span className={"fw-bold"}> Customer: </span>
                  {
                    customersList?.find(
                      (customer) =>
                        customer?.Id === contractItemObject?.Customer_Id
                    )?.FullName
                  }
                </span>
              )}
            </>
          )
        }
        icon={<AssignmentOutlinedIcon />}
        headerAccent="indigo"
        size="lg"
        hideFooter
      >
          {" "}
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody className="form-steps">
                  <form className="vertical-navs-step">
                    <Row className="gy-5">
                      <Col lg={3}>
                        <Nav className="flex-column custom-nav nav-pills">
                          <NavItem>
                            <NavLink
                              href="#"
                              className={classnames({
                                active: activeVerticalTab === 7,
                                done:
                                  activeVerticalTab <= 11 &&
                                  activeVerticalTab > 7,
                              })}
                              onClick={() => {
                                toggleVerticalTab(7);
                              }}
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2"></i>
                                Step 1
                              </span>
                              Customer / Contract
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              href="#"
                              className={classnames({
                                active: activeVerticalTab === 8,
                                done:
                                  activeVerticalTab <= 11 &&
                                  activeVerticalTab >= 8,
                              })}
                              onClick={() => {
                                toggleVerticalTab(8);
                              }}
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2"></i>
                                Step 2
                              </span>
                              Contract Options
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              href="#"
                              className={classnames({
                                active: activeVerticalTab === 9,
                                done:
                                  activeVerticalTab <= 11 &&
                                  activeVerticalTab >= 9,
                              })}
                              onClick={() => {
                                toggleVerticalTab(9);
                              }}
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2"></i>
                                Step 3
                              </span>
                              Contract Items
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              href="#"
                              className={classnames({
                                active: activeVerticalTab === 10,
                                done:
                                  activeVerticalTab <= 11 &&
                                  activeVerticalTab >= 10,
                              })}
                              onClick={() => {
                                toggleVerticalTab(10);
                              }}
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2"></i>
                                Step 4
                              </span>
                              Finish
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Col>
                      <Col
                        lg={
                          contractItems_list.some(
                            (item) => item.selectedProduct.id
                          )
                            ? 6
                            : 9
                        }
                      >
                        <div className="px-lg-4">
                          <TabContent activeTab={activeVerticalTab}>
                            <TabPane tabId={7}>
                              <div>
                                <h5>Customer</h5>
                              </div>

                              <div>
                                <Row className="g-3">
                                  <Col xs={12}>
                                    <Select
                                      isClearable={true}
                                      className="mb-0 job-select2"
                                      placeholder={"Select Customer"}
                                      value={
                                        contractItemObject.Customer_Id
                                          ? {
                                              label: customersList?.find(
                                                (item) =>
                                                  item.Id ===
                                                  contractItemObject.Customer_Id
                                              )?.FullName,
                                            }
                                          : []
                                      }
                                      onChange={(e) => {
                                        setContractItemObject({
                                          ...contractItemObject,
                                          Customer_Id: e?.value ?? "",
                                        });
                                      }}
                                      options={
                                        !isEmpty(customersList)
                                          ? customersList?.map((item) => ({
                                              label: item?.FullName,
                                              value: item?.Id,
                                              id: item?.Id,
                                            }))
                                          : []
                                      }
                                      id="country-select"
                                    ></Select>
                                  </Col>
                                  <Col xs={12}>
                                    <div>
                                      <h5>Contract Details</h5>
                                    </div>
                                  </Col>
                                  <Col sm={6}>
                                    <Label
                                      htmlFor="firstName"
                                      className="form-label"
                                    >
                                      Title
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="firstName"
                                      placeholder="Enter Title"
                                      value={contractItemObject?.Title}
                                      onChange={(e) => {
                                        setContractItemObject({
                                          ...contractItemObject,
                                          Title: e.target.value,
                                        });
                                      }}
                                    />
                                  </Col>{" "}
                                  <Col sm={6}>
                                    <Label
                                      htmlFor="firstName"
                                      className="form-label"
                                    >
                                      Printed Title
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="firstName"
                                      placeholder="Enter Printed Title"
                                      value={contractItemObject?.TitlePrinted}
                                      onChange={(e) => {
                                        setContractItemObject({
                                          ...contractItemObject,
                                          TitlePrinted: e.target.value,
                                        });
                                      }}
                                    />
                                  </Col>
                                  <Col sm={12}>
                                    <Label
                                      htmlFor="lastName"
                                      className="form-label"
                                    >
                                      Description
                                    </Label>
                                    <textarea
                                      className="form-control"
                                      id="lastName"
                                      placeholder="Enter description"
                                      value={contractItemObject?.Description}
                                      onChange={(e) => {
                                        setContractItemObject({
                                          ...contractItemObject,
                                          Description: e.target.value,
                                        });
                                      }}
                                    />
                                  </Col>
                                </Row>
                              </div>

                              <div className="d-flex align-items-start gap-3 mt-4">
                                <button
                                  type="button"
                                  className="btn btn-success btn-label right ms-auto nexttab nexttab"
                                  onClick={() => {
                                    toggleVerticalTab(activeVerticalTab + 1);
                                  }}
                                >
                                  <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                  Options
                                </button>
                              </div>
                            </TabPane>

                            <TabPane tabId={8}>
                              <div>
                                <h5>Contract Options</h5>
                              </div>

                              <div>
                                <Row className="g-3">
                                  <Col xs={6}>
                                    <Label
                                      htmlFor="address"
                                      className="form-label"
                                    >
                                      Start Date
                                    </Label>
                                    <AppDatePicker
                                      slotProps={{
                                        textField: {
                                          placeholder:
                                            "Select Contract Start Date",
                                        },
                                      }}
                                      value={
                                        contractItemObject?.StartDateTime
                                          ? moment(
                                              contractItemObject?.StartDateTime
                                            )
                                          : null
                                      }
                                      onChange={(val) => {
                                        const jsDate =
                                          val && val.isValid()
                                            ? val.toDate()
                                            : null;
                                        setContractItemObject({
                                          ...contractItemObject,
                                          StartDateTime: jsDate
                                            ? handleValidDateTime(jsDate)
                                            : "",
                                        });
                                      }}
                                    />
                                  </Col>
                                  <Col xs={6}>
                                    <Label
                                      htmlFor="address"
                                      className="form-label"
                                    >
                                      End Date
                                    </Label>
                                    <AppDatePicker
                                      slotProps={{
                                        textField: {
                                          placeholder: "Select End Date",
                                        },
                                      }}
                                      value={
                                        contractItemObject?.EndDateTime
                                          ? moment(
                                              contractItemObject?.EndDateTime
                                            )
                                          : null
                                      }
                                      onChange={(val) => {
                                        const jsDate =
                                          val && val.isValid()
                                            ? val.toDate()
                                            : null;
                                        setContractItemObject({
                                          ...contractItemObject,
                                          EndDateTime: jsDate
                                            ? handleValidDateTime(jsDate)
                                            : "",
                                        });
                                      }}
                                    />
                                  </Col>
                                  <Col xs={6}>
                                    <Label
                                      htmlFor="address"
                                      className="form-label"
                                    >
                                      Renewal Date
                                    </Label>
                                    <AppDatePicker
                                      slotProps={{
                                        textField: {
                                          placeholder: "Select Renewal Date",
                                        },
                                      }}
                                      value={
                                        contractItemObject?.RenewalDateTime
                                          ? moment(
                                              contractItemObject?.RenewalDateTime
                                            )
                                          : null
                                      }
                                      onChange={(val) => {
                                        const jsDate =
                                          val && val.isValid()
                                            ? val.toDate()
                                            : null;
                                        setContractItemObject({
                                          ...contractItemObject,
                                          RenewalDateTime: jsDate
                                            ? handleValidDateTime(jsDate)
                                            : "",
                                        });
                                      }}
                                    />
                                  </Col>
                                  <Col xs={6}>
                                    <Label
                                      htmlFor="address"
                                      className="form-label"
                                    >
                                      Preferred Billing Cycle Day
                                    </Label>
                                    <Select
                                      className="mb-0 job-select2"
                                      placeholder={"None"}
                                      value={
                                        contractItemObject?.PreferredBillingCycleDay
                                      }
                                      onChange={(e) =>
                                        setContractItemObject({
                                          ...contractItemObject,
                                          PreferredBillingCycleDay: e,
                                        })
                                      }
                                      options={preferredBillingCycleDayList.map(
                                        (item) => ({
                                          label: item.label,
                                          value: item.id,
                                          id: item.id,
                                        })
                                      )}
                                      id="country-select"
                                    ></Select>
                                  </Col>
                                  <Col xs={6}>
                                    <Label
                                      htmlFor="address"
                                      className="form-label"
                                    >
                                      Contract Status
                                    </Label>
                                    <Select
                                      className="mb-0 job-select2"
                                      placeholder={"Select Contract Status"}
                                      value={
                                        contractItemObject?.ContractStatus_Id
                                      }
                                      onChange={(e) =>
                                        setContractItemObject({
                                          ...contractItemObject,
                                          ContractStatus_Id: e,
                                        })
                                      }
                                      options={
                                        !isEmpty(ContractStatusListApi)
                                          ? ContractStatusListApi?.map(
                                              (item) => ({
                                                label: item.Name,
                                                value: item.Id,
                                                id: item.Id,
                                              })
                                            )
                                          : []
                                      }
                                      id="country-select"
                                    ></Select>
                                  </Col>
                                  <Col xs={6}>
                                    <Label
                                      htmlFor="address"
                                      className="form-label"
                                    >
                                      Renewal Frequency
                                    </Label>
                                    <Select
                                      className="mb-0 job-select2"
                                      placeholder={"Select Renewal Frequency"}
                                      value={
                                        contractItemObject?.UnitFrequency_Id
                                      }
                                      onChange={(e) =>
                                        setContractItemObject({
                                          ...contractItemObject,
                                          UnitFrequency_Id: e,
                                        })
                                      }
                                      options={
                                        !isEmpty(ContractUnitFrequencyListApi)
                                          ? ContractUnitFrequencyListApi?.map(
                                              (item) => ({
                                                label: item.Name,
                                                value: item.Id,
                                                id: item.Id,
                                              })
                                            )
                                          : []
                                      }
                                      id="country-select"
                                    ></Select>
                                  </Col>
                                  <Col xs={6}>
                                    <Label
                                      htmlFor="address"
                                      className="form-label"
                                    >
                                      Payment Method
                                    </Label>
                                    <Select
                                      className="mb-0 job-select2"
                                      placeholder={"Select Payment Method"}
                                      value={
                                        contractItemObject?.PaymentMethod_Id
                                      }
                                      onChange={(e) =>
                                        setContractItemObject({
                                          ...contractItemObject,
                                          PaymentMethod_Id: e,
                                        })
                                      }
                                      options={
                                        !isEmpty(paymentMethodList)
                                          ? paymentMethodList?.map((item) => ({
                                              label: item.Name,
                                              value: item.Id,
                                              id: item.Id,
                                            }))
                                          : []
                                      }
                                      id="country-select"
                                    ></Select>
                                  </Col>
                                </Row>

                                <Row className="g-3 mt-1">
                                  <Col xs={6}>
                                    <Label
                                      htmlFor="due-date-amount"
                                      className="form-label"
                                    >
                                      Due Date Amount
                                    </Label>
                                    <Input
                                      id="due-date-amount"
                                      type="number"
                                      className="form-control"
                                      placeholder={"e.g. 2"}
                                      value={
                                        contractItemObject?.DueDateTimeLogicValue ??
                                        ""
                                      }
                                      onChange={(e) =>
                                        setContractItemObject({
                                          ...contractItemObject,
                                          DueDateTimeLogicValue: e.target.value,
                                        })
                                      }
                                    />
                                  </Col>
                                  <Col xs={6}>
                                    <Label
                                      htmlFor="due-date-interval"
                                      className="form-label"
                                    >
                                      Due Date Interval
                                    </Label>
                                    <Select
                                      className="mb-0 job-select2"
                                      placeholder={"Select Interval"}
                                      value={
                                        contractItemObject?.DueDateTimeLogic_MasterTimeFrameInterval_Id
                                      }
                                      onChange={(e) =>
                                        setContractItemObject({
                                          ...contractItemObject,
                                          DueDateTimeLogic_MasterTimeFrameInterval_Id:
                                            e,
                                        })
                                      }
                                      options={
                                        !isEmpty(masterTimeFrameIntervalList)
                                          ? masterTimeFrameIntervalList?.map(
                                              (interval) => ({
                                                label: interval?.Name,
                                                value: interval?.Id,
                                                id: interval?.Id,
                                              })
                                            )
                                          : []
                                      }
                                      id="due-date-interval"
                                    ></Select>
                                  </Col>
                                </Row>

                                <hr className="my-4 text-muted" />

                                <div className="form-check">
                                  <Input
                                    checked={
                                      contractItemObject?.AutoInvoiceEmail === 1
                                    }
                                    onChange={() => {
                                      setContractItemObject({
                                        ...contractItemObject,
                                        AutoInvoiceEmail: helperSwapNumber(
                                          Number(
                                            contractItemObject.AutoInvoiceEmail
                                          )
                                        ),
                                      });
                                    }}
                                    type="checkbox"
                                    className="form-check-input"
                                    id="same-address"
                                  />
                                  <Label
                                    className="form-check-label"
                                    htmlFor="save-info"
                                  >
                                    Auto Invoice Email
                                  </Label>
                                </div>
                              </div>
                              <div className="d-flex align-items-start gap-3 mt-4">
                                <button
                                  type="button"
                                  className="btn btn-light btn-label previestab"
                                  onClick={() => {
                                    toggleVerticalTab(activeVerticalTab - 1);
                                  }}
                                >
                                  <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>{" "}
                                  Customer / Contract
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-success btn-label right ms-auto nexttab"
                                  onClick={() => {
                                    toggleVerticalTab(activeVerticalTab + 1);
                                  }}
                                >
                                  <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                  Contract Items
                                </button>
                              </div>
                            </TabPane>

                            <TabPane tabId={9}>
                              <TabContractItems
                                toggleVerticalTab={toggleVerticalTab}
                                activeVerticalTab={activeVerticalTab}
                                contractItemObject={contractItemObject}
                                setContractItemObject={setContractItemObject}
                                contractItems_list={contractItems_list}
                                searchResults={searchResults}
                                searchQuery={searchQuery}
                                setSearchQuery={setSearchQuery}
                                setContractItems_list={setContractItems_list}
                                sortByChoice={sortByChoice}
                                sortBy={sortBy}
                                setSortBy={setSortBy}
                                setSortByChoice={setSortByChoice}
                                customersList={customersList}
                              />
                              <div className="d-flex align-items-start ">
                                <button
                                  type="button"
                                  className="btn btn-light btn-label previestab"
                                  onClick={() => {
                                    toggleVerticalTab(activeVerticalTab - 1);
                                  }}
                                >
                                  <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>{" "}
                                  Back to Options
                                </button>
                                {CreateContractWithItemsSuccessLoading ||
                                updateContractWithItemsSuccessLoading ? (
                                  <div className={"ms-2"}>
                                    <LoadingSpinner size={"small"} row={true} />
                                  </div>
                                ) : (
                                  <button
                                    type="button"
                                    className="btn btn-success btn-label right ms-auto nexttab"
                                    onClick={() => {
                                      // toggleVerticalTab(activeVerticalTab + 1);
                                      if (isEdit) {
                                        handleUpdateContractWithItems();
                                      } else {
                                        handleCreateContractWithItems();
                                      }
                                    }}
                                  >
                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>{" "}
                                    {isEdit ? "Update" : "Create"}
                                  </button>
                                )}
                              </div>
                            </TabPane>

                            <TabPane tabId={10}>
                              <TabFinish
                                contractItemObject={contractItemObject}
                                contractItems_list={contractItems_list}
                                customersList={customersList}
                                restructuredDate={RestructuredDate}
                              />
                              <div
                                className={
                                  "text-center pt-4 d-flex justify-content-between"
                                }
                              >
                                <span
                                  onClick={() => {
                                    toggleVerticalTab(9);
                                  }}
                                  className={"btn btn-soft-warning"}
                                >
                                  Add / Edit / Remove Items
                                </span>
                                <span
                                  onClick={() => {
                                    setModalCreateContractItem(false);
                                    setIsEdit(false);
                                  }}
                                  className={"btn btn-soft-danger"}
                                >
                                  Close
                                </span>
                              </div>
                            </TabPane>
                          </TabContent>
                        </div>
                      </Col>

                      {/* Right Sidebar */}
                      {contractItems_list?.some(
                        (item) => item.selectedProduct.id
                      ) && (
                        <Col
                          lg={3}
                          className={"contract-iems-colmn-side-bar-container"}
                        >
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="fs-14 text-primary mb-0">
                              <i className="ri-shopping-cart-fill align-middle me-2"></i>{" "}
                              Contract Items
                            </h5>
                            <span className="badge bg-danger rounded-pill">
                              {contractItems_list.length}
                            </span>
                          </div>
                          <ul className="list-group mb-3">
                            {contractItems_list?.map((item, index) => (
                              <li
                                key={index}
                                className={
                                  item?.show_item
                                    ? "list-group-item bg-soft-success"
                                    : "list-group-item li-lit-contract-items-container"
                                }
                                onClick={() => {
                                  handleItemBasketItemClose(item?.id);
                                }}
                              >
                                <div
                                  className={"lit-contract-items-container "}
                                >
                                  <div>
                                    <h6 className="my-0">
                                      #{item?.id}{" "}
                                      {item?.Title?.length > 16
                                        ? item?.Title.substring(0, 16) + "..."
                                        : item?.Title}
                                    </h6>
                                    <small className="text-muted">
                                      {item?.Description?.length > 25
                                        ? item?.Description?.substring(0, 25) +
                                          "..."
                                        : item?.Description}
                                    </small>
                                  </div>
                                  <div>
                                    <span className="text-muted">
                                      £
                                      {(item?.rate * item?.quantity).toFixed(2)}
                                    </span>
                                  </div>
                                </div>
                              </li>
                            ))}
                            <li className="list-group-item d-flex flex-column align-items-end lh-sm">
                              <div>
                                <div
                                  className={
                                    "d-flex align-items-center justify-content-end"
                                  }
                                >
                                  <div
                                    className={
                                      "d-flex align-items-center justify-content-end"
                                    }
                                  >
                                    <h6 className="my-0 pe-1">Sub Total </h6>
                                    <small className="text-muted">
                                      {" "}
                                      £
                                      {contractItems_list
                                        ?.reduce(
                                          (total, item) =>
                                            total + item.rate * item.quantity,
                                          0
                                        )
                                        .toFixed(2)}
                                    </small>
                                  </div>
                                </div>
                                <div
                                  className={
                                    "d-flex align-items-center justify-content-end"
                                  }
                                >
                                  <div
                                    className={
                                      "d-flex align-items-center justify-content-end"
                                    }
                                  >
                                    <h6 className="my-0 pe-1">Total Amount</h6>
                                    <small className="text-muted">
                                      £
                                      {(
                                        contractItems_list?.reduce(
                                          (total, item) =>
                                            total + item.rate * item.quantity,
                                          0
                                        ) +
                                        contractItems_list?.reduce(
                                          (total, item) =>
                                            total +
                                            (item.rate *
                                              item.quantity *
                                              item.vatRate) /
                                              100,
                                          0
                                        )
                                      ).toFixed(2)}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            </li>
                            {
                              //check difference in reducing both before and after if match if not then show the difference
                              contractItemsReducedLocalStateTotalIncVat !==
                                contractItemsReducedAPiTotalIncVat &&
                                isEdit && (
                                  <li className="list-group-item d-flex flex-column align-items-end lh-sm">
                                    <div className={""}>
                                      <div
                                        className={
                                          "d-flex align-items-center justify-content-end"
                                        }
                                      >
                                        <h6 className="my-0 pe-1">
                                          Before Sub Total{" "}
                                        </h6>
                                        <small className="text-muted">
                                          {" "}
                                          £
                                          {contractItemsReducedAPiTotal?.toFixed(
                                            2
                                          )}{" "}
                                        </small>
                                      </div>

                                      <div className={"text-end"}>
                                        {
                                          // check if reduced getSingleContractItem_Contract_Item_List is greater than contractItems_list then show the difference
                                          contractItemsReducedAPiTotal >
                                            contractItemsReducedLocalStateTotal && (
                                            <small className="text-danger">
                                              {" "}
                                              -£
                                              {(
                                                contractItemsReducedAPiTotal -
                                                contractItemsReducedLocalStateTotal
                                              ).toFixed(2)}
                                            </small>
                                          )
                                        }
                                        {
                                          // check if reduced getSingleContractItem_Contract_Item_List is less than contractItems_list then show the difference
                                          contractItemsReducedAPiTotal <
                                            contractItemsReducedLocalStateTotal && (
                                            <small className="text-success">
                                              {" "}
                                              +£
                                              {(
                                                contractItemsReducedLocalStateTotal -
                                                contractItemsReducedAPiTotal
                                              )?.toFixed(2)}
                                            </small>
                                          )
                                        }
                                      </div>
                                    </div>
                                    <div
                                      className={
                                        "d-flex align-items-center justify-content-end"
                                      }
                                    >
                                      <h6 className="my-0 pe-1">
                                        Before Total Amount
                                      </h6>
                                      <small className="text-muted">
                                        £
                                        {contractItemsReducedAPiTotalIncVat?.toFixed(
                                          2
                                        )}
                                      </small>
                                    </div>
                                    <div className={"text-end"}>
                                      {
                                        // check if reduced getSingleContractItem_Contract_Item_List is greater than contractItems_list then show the difference
                                        contractItemsReducedAPiTotalIncVat >
                                          contractItemsReducedLocalStateTotalIncVat && (
                                          <small className="text-danger">
                                            {" "}
                                            -£
                                            {(
                                              contractItemsReducedAPiTotalIncVat -
                                              contractItemsReducedLocalStateTotalIncVat
                                            )?.toFixed(2)}
                                          </small>
                                        )
                                      }
                                      {
                                        // check if reduced getSingleContractItem_Contract_Item_List is less than contractItems_list then show the difference
                                        contractItemsReducedAPiTotalIncVat <
                                          contractItemsReducedLocalStateTotalIncVat && (
                                          <small className="text-success">
                                            {" "}
                                            +£
                                            {(
                                              contractItemsReducedLocalStateTotalIncVat -
                                              contractItemsReducedAPiTotalIncVat
                                            )?.toFixed(2)}
                                          </small>
                                        )
                                      }
                                    </div>
                                  </li>
                                )
                            }
                          </ul>
                        </Col>
                      )}
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
      </AppModal>
    </div>
  );
};

export default CreateContractItem;
